import { Component, OnDestroy, OnInit } from '@angular/core';
import { CredentialsTokensType } from '@cargos/sprintpay-models';
import { StorageService, StorageTypes } from '@cargos/sprintpay-services';
import { Observable, Subject, take } from 'rxjs';
import { DynamicDialogService } from 'src/app/shared/components';
import { SessionService } from 'src/app/shared/services';
import { MessageModalComponent } from '../../../components/message/message.component';

@Component({
    selector: 'app-search-awb',
    templateUrl: './search-awb.component.html',
    styleUrls: ['./search-awb.component.scss'],
    standalone: false,
})
export class SearchAwbComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public dhlBackground: string[];
    public mobileQuery: MediaQueryList;
    constructor(
        private sessionService: SessionService,
        private storageService: StorageService,
        private dynamicDialogService: DynamicDialogService
    ) {
        this.dhlBackground = ['assets/dhl-aviation/img/bg.webp'];
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.reviewFacilitySource();
        this.isValidShowModal();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    reviewFacilitySource(): void {
        if (!this.userHasToken()) {
            this.signInAsAGuest().pipe(take(1)).subscribe();
        }
    }

    userHasToken(): boolean {
        return this.sessionService.hasToken();
    }

    signInAsAGuest(): Observable<CredentialsTokensType> {
        return this.sessionService.signInAsAGuest();
    }

    isValidShowModal(): void {
        const session = this.storageService.getElement<boolean>('displayedModal', StorageTypes.SESSION);

        if (session) {
            return;
        }

        this.storageService.saveElement<boolean>('displayedModal', true, StorageTypes.SESSION);

        this.openMessageModal();
    }

    openMessageModal(): void {
        this.dynamicDialogService.showDialog<MessageModalComponent>({
            dynamicComponent$: MessageModalComponent,
            closeButton: true,
            config: {
                id: 'dhlMessage',
                closeOnNavigation: true,
            },
        });
    }
}
